import React from 'react';
import PropTypes from 'prop-types';

import {
  PERMISSION_TYPES,
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_VIEW_ACCESS,
} from '../../../../../constants/contributors';
import ContributorFeatureBlock from './ContributorFeatureBlock';

const propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  checkType: PropTypes.oneOf(Object.values(CONTRIBUTOR_PERMISSION_CHECK_TYPE)),
  entityId: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.string),
  fallbackContent: PropTypes.any,
};

const ViewPermissionBlock = ({
  entityId,
  permissions = [CONTRIBUTOR_VIEW_ACCESS.ALL, CONTRIBUTOR_VIEW_ACCESS.OWN],
  checkType,
  children,
  ...props
}) => {
  const viewPermissionProps = {
    entityId,
    checkType,
    permissions: permissions.map(permission => ({
      permission,
      type: PERMISSION_TYPES.VIEW_ACCESS,
    })),
  };

  return (
    <ContributorFeatureBlock
      {...props}
      contributorPermissionProps={viewPermissionProps}
    >
      {children}
    </ContributorFeatureBlock>
  );
};

ViewPermissionBlock.propTypes = propTypes;

export default ViewPermissionBlock;
